/* eslint-disable react-hooks/exhaustive-deps */
import {
   Modal as AModal,
   Callout,
   IconButton,
   Typography,
} from '@airtel/air-design-system';
import { ButtonWidget, StatusCardWidget} from '@airtel/air-widgets-library';
import {
   FaceDetection,
   FaceDetectionErrorCodeType,
   FaceDetectionRefType,
} from '@airtel/air-vision-camera';
import { FC, useEffect, useRef, useState } from 'react';
import { Modal } from 'react-native';
import faviconIcon from '../../assets/images/png/airtel.png';
import { getInteractionId, generateUniqueId } from '../../common/commonUtils';
import { convertTimestampToDate } from '../../common/otpUtils';
import { prepareFormData } from '../../common/uploadUtils';
import {
   closeCameraModalWithErrorAction,
   ImageStore,
} from '../../common/userImageUploadUtilsRevamp';
import FullScreenLoader from '../full-screen-loader';
import ModalCloseButton from '../modal-close-button';
import { ImageModalPropsTypes } from './ImageModalPropTypes';
import ImagePreview from './ImagePreview';
import './imageModalStyles.scss';

const CROP_TARGET_HEIGHT = 1024;
const CROP_PORTRAIT_ASPECT_RATIO = 3 / 4;
const JPEG_QUALITY = 0.95;
const ZOOM_FACTOR = 0.85; // NEW — lower = tighter zoom on the face, less background. Tune this.

const WATERMARK_FONT_SIZE = 18;
const WATERMARK_FONT = `bold ${WATERMARK_FONT_SIZE}px Arial, Helvetica, sans-serif`;
const WATERMARK_TEXT_COLOR = '#000000';
const WATERMARK_TEXT_BG_COLOR = 'rgba(255, 255, 255, 0.63)';
const WATERMARK_ICON_SIZE = 50;
const WATERMARK_ICON_TO_TEXT_GAP = 8;
const WATERMARK_TEXT_BG_PADDING_H = 6;
const WATERMARK_TEXT_BG_PADDING_V = 2;
const WATERMARK_LINE_SPACING = 4;
const WATERMARK_CORNER_RADIUS = 6;
const WATERMARK_EDGE_PADDING_LEFT = 36;
const WATERMARK_EDGE_PADDING_BOTTOM = 32;

const ImageModalRevamp: FC<ImageModalPropsTypes> = (props) => {
   const {
      visible,
      artistRef,
      getReduxState,
      userLocation = {},
      isUploaded,
      showFaceMatchError,
      faceMathErrorText,
      setShowFaceMathError,
      setIsImageModalOpen,
   } = props;
   let { latitude = '', longitude = '' } = userLocation;
   const [location, setLocation] = useState({
      latitude: '',
      longitude: ''
    });

   const faceDetectionRef = useRef<FaceDetectionRefType>(null);

   const [imageWithWaterMark, setImageWithWaterMark] = useState('');
   const [rawImage, setRawImage] = useState('');
   const [detectedFaceCount, setDetectedFaceCount] = useState<number | null>(null);
   const [loader, setLoader] = useState(true);
   const [eyesCallout, setEyesCallout] = useState(false);
   const [isFaceValid, setIsFaceValid] = useState(false);
   const airtelIconRef = useRef<ImageBitmap | null>(null);

   console.log("revamp img modal>>>")

   useEffect(() => {
      const reduxState = getReduxState?.();
      const storeValues = reduxState?.storeValues;
      latitude = storeValues?.appData?.address?.latitude;
      longitude = storeValues?.appData?.address?.longitude;

      setLocation(prev => ({
         ...prev,
         latitude: latitude || '',
         longitude: longitude || ''
      }));
   }, [visible, imageWithWaterMark]);

   useEffect(() => {
      const actions = [];
      const reduxState = getReduxState?.();
      const storeValues = reduxState?.storeValues;
      const isNewSKYCJourney = storeValues?.journeyContext?.journey === 'SKYC_NEW';
      if (detectedFaceCount === 0) {
         if (isNewSKYCJourney) {
            actions?.push({
               analyticsAction: 'click',
               analyticsData: {
                  eventCategory: 'NEW_ACQ_POSTPAID_SKYC',
                  section: 'stepsSection',
                  subSection: 'Step4Widget',
                  eventAction: 'impression',
                  eventLabel: 'retry',
                  eventValue: 'ensure that your face is clearly visible in the photo',
                  customValue: '',
                  customLabel: 'card',
                  prop35: '{{storeValues:orderData.orderData.cartId}}',
                  extraData12: '{{storeValues:orderData.orderData.cartItemId}}',
                  prop45: '{{storeValues:appData.subJourney}}',
                  eVar21: '{{storeValues:appData.loggedInNumber}}',
                  eVar36: '{{storeValues:appData.msisdn}}',
                  city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
                  eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleName}}',
                  prop4: 'SKYC',
                  extraData11: '{{storeValues:layoutContext.layout}}',
                  prop7: '{{storeValues:outstationContext.isOutstation}}',
                  prop9: '{{storeValues:appData.lob}}',
                  eVar10: 'error'
               },
            });
         } else {
            actions.push({
               analyticsAction: 'click',
               analyticsData: {
                  eventCategory: 'SKYC_LANDING_PAGE',
                  section: 'stepssection',
                  subSection: 'Step4Widget',
                  eventAction: 'error',
                  eventLabel: 'face not visible',
                  eventValue: 'Ensure that your face is clearly visible in the photo.',
                  eVar21: '{{storeValues:appData.msisdn}}',
                  extraData11: '{{storeValues:layoutContext.layout}}',
                  prop8: 'reverification',
                  prop6: '{{storeValues:siNumberStatusDetails.actionRequired}}',
                  prop7: '{{storeValues:siNumberStatusDetails.customerZone}}',
                  prop5: '{{storeValues:outstationContext.isOutstation}}',
               },
            });
         }
      } else if (detectedFaceCount !== 1) {
         actions.push({
            analyticsAction: 'click',
            analyticsData: {
               eventCategory: 'SKYC_LANDING_PAGE',
               section: 'stepssection',
               subSection: 'Step4Widget',
               eventAction: 'error',
               eventLabel: 'Multiple faces detected.',
               eventValue: 'Multiple faces detected.',
               eVar21: '{{storeValues:appData.msisdn}}',
               extraData11: '{{storeValues:layoutContext.layout}}',
               prop8: 'reverification',
               prop6: '{{storeValues:siNumberStatusDetails.actionRequired}}',
               prop7: '{{storeValues:siNumberStatusDetails.customerZone}}',
               prop5: '{{storeValues:outstationContext.isOutstation}}',
            },
         });
      }

      if(eyesCallout){
         if (isNewSKYCJourney) {
            actions?.push({
               analyticsAction: 'click',
               analyticsData: {
                  eventCategory: 'NEW_ACQ_POSTPAID_SKYC',
                  section: 'stepsSection',
                  subSection: 'Step4Widget',
                  eventAction: 'impression',
                  eventLabel: 'retry',
                  eventValue: 'ensure that your eyes are open in the photo',
                  customValue: '',
                  customLabel: 'card',
                  prop35: '{{storeValues:orderData.orderData.cartId}}',
                  extraData12: '{{storeValues:orderData.orderData.cartItemId}}',
                  prop45: '{{storeValues:appData.subJourney}}',
                  eVar21: '{{storeValues:appData.loggedInNumber}}',
                  eVar36: '{{storeValues:appData.msisdn}}',
                  city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
                  eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleName}}',
                  prop4: 'SKYC',
                  extraData11: '{{storeValues:layoutContext.layout}}',
                  prop7: '{{storeValues:outstationContext.isOutstation}}',
                  prop9: '{{storeValues:appData.lob}}',
                  eVar10: 'error'
               },
            });
         } 
      }

      if (actions.length) artistRef?.current?.onUserAction({ actions });
   }, [detectedFaceCount]);

   const applyErrorCode = (isValid: boolean, code?: FaceDetectionErrorCodeType) => {
      setIsFaceValid(isValid);
      if (isValid) {
         setDetectedFaceCount(1);
         setEyesCallout(false);
         return;
      }
      switch (code) {
         case 'MULTIPLE_FACES':
            setDetectedFaceCount(2);
            setEyesCallout(false);
            break;
         case 'EYES_NOT_VISIBLE':
            setDetectedFaceCount(1);
            setEyesCallout(true);
            break;
         case 'NO_FACE_IN_CIRCLE':
         case 'HUMAN_FACE_CONFIDENCE':
         case 'FACE_NOT_LOOKING_FRONT':
         default:
            setDetectedFaceCount(0);
            setEyesCallout(false);
            break;
      }
   };

   const handleFaceCaptureResult = async (imageBlob?: string) => {
      if (!imageBlob) {
         setLoader(false);
         return;
      }
      if (isUploaded) isUploaded.current = false;
      try {
         setRawImage(await getProcessedImage(imageBlob));
         setImageWithWaterMark(await getProcessedImage(imageBlob, true));
      } catch {
         // capturePhoto already stopped the camera, and with no preview to
         // unmount FaceDetection nothing would reboot it, so do it here.
         faceDetectionRef.current?.startCapture();
      } finally {
         setLoader(false);
      }
   };

   const capturePhoto = async () => {
      if (!isFaceValid) return;
      const reduxState = getReduxState?.();
      const storeValues = reduxState?.storeValues;
      const isNewSKYCJourney = storeValues?.journeyContext?.journey === 'SKYC_NEW';
      const isPrepaidSimLayout = storeValues?.journeyContext?.layout === 'prepaid_sim_layout'
      setLoader(true);
      faceDetectionRef.current?.stopCapture();
      const actions = [];

      if (!isPrepaidSimLayout) {
         actions.push({
            analyticsAction: 'click',
            analyticsData: {
               eventCategory: 'SKYC_LANDING_PAGE',
               section: 'stepssection',
               subSection: 'Step4Widget',
               eventAction: 'click',
               eventLabel: 'capture picture',
               eVar21: '{{storeValues:appData.msisdn}}',
               extraData11: '{{storeValues:layoutContext.layout}}',
               prop8: 'reverification',
               prop6: '{{storeValues:siNumberStatusDetails.actionRequired}}',
               prop7: '{{storeValues:siNumberStatusDetails.customerZone}}',
               prop5: '{{storeValues:outstationContext.isOutstation}}',
            },
         });
      } else {
         actions.push({
            analyticsAction: 'click',
            analyticsData: {
               eventCategory: "new_acq_postpaid_skyc",
               section: "stepsSection",
               subSection: "Step4Widget",
               eVar33: "{{storeValues:pincodeContext.pincodeDetails.pincode}}",
               eVar21: "{{storeValues:appData.msisdn}}",
               eVar20: "{{storeValues:appData.loggedInNumber}}",
               city: "{{storeValues:pincodeContext.pincodeDetails.city}}",
               customValue: "",
               eVar36: "{{storeValues:trackOrderContext.selectedMsisdn}}",
               eVar25: "{{storeValues:pincodeContext.pincodeDetails.circleId}}",
               isInteractive: 1,
               cartId: "{{storeValues:orderData.cartItemId}}",
               eventAction: "click",
               eventLabel: "capture photo",
               prop5: "{{storeValues:planInfo.planName}}",
               prop4: "SKYC",
               eventValue: "photo verification",
               eVar0: "skyc_click on photo capture",
               customLabel: "button",
               prop45: "{{storeValues:appData.orderType}}",
               ticketId: "{{storeValues:orderData.cartId}}",
               prop26: ""
            },
         });
      }

      artistRef?.current?.onUserAction({
         actions,
      });
   };

   const onPressRetry = () => {
      setImageWithWaterMark('');
      setRawImage('');
      setIsFaceValid(false);
      setDetectedFaceCount(null);
      setEyesCallout(false);

      const actions = [];
      const reduxState = getReduxState?.();
      const storeValues = reduxState?.storeValues;
      const isNewSKYCJourney = storeValues?.journeyContext?.journey === 'SKYC_NEW';
      const isPrepaidSimLayout = storeValues?.journeyContext?.layout === 'prepaid_sim_layout'

      if (!isPrepaidSimLayout) {
         if (isNewSKYCJourney) {
            actions?.push({
               analyticsAction: 'click',
               analyticsData: {
                  eventCategory: 'NEW_ACQ_POSTPAID_SKYC',
                  section: 'stepsSection',
                  subSection: 'Step4Widget',
                  eventAction: 'click',
                  eventLabel: 'retry',
                  eventValue: '',
                  customValue: '',
                  customLabel: 'button',
                  prop35: '{{storeValues:orderData.orderData.cartId}}',
                  extraData12: '{{storeValues:orderData.orderData.cartItemId}}',
                  prop45: '{{storeValues:appData.subJourney}}',
                  eVar21: '{{storeValues:appData.loggedInNumber}}',
                  eVar36: '{{storeValues:appData.msisdn}}',
                  city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
                  eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleName}}',
                  prop4: 'SKYC',
                  extraData11: '{{storeValues:layoutContext.layout}}',
                  prop7: '{{storeValues:outstationContext.isOutstation}}',
                  prop9: '{{storeValues:appData.lob}}'
               },
            });
         } else {
            actions.push({
               analyticsAction: 'click',
               analyticsData: {
                  eventCategory: 'SKYC_LANDING_PAGE',
                  section: 'stepssection',
                  subSection: 'Step4Widget',
                  eventAction: 'click',
                  eventLabel: 'retry picture',
                  eVar21: '{{storeValues:appData.msisdn}}',
                  extraData11: '{{storeValues:layoutContext.layout}}',
                  prop8: 'reverification',
                  prop6: '{{storeValues:siNumberStatusDetails.actionRequired}}',
                  prop7: '{{storeValues:siNumberStatusDetails.customerZone}}',
                  prop5: '{{storeValues:outstationContext.isOutstation}}',
               },
            });
         }
      } else {
         actions.push({
            analyticsAction: 'click',
            analyticsData: {
               eventCategory: "new_acq_postpaid_skyc",
               section: "stepsSection",
               subSection: "Step4Widget",
               eVar33: "{{storeValues:pincodeContext.pincodeDetails.pincode}}",
               eVar21: "{{storeValues:appData.msisdn}}",
               eVar20: "{{storeValues:appData.loggedInNumber}}",
               city: "{{storeValues:pincodeContext.pincodeDetails.city}}",
               customValue: "",
               eVar36: "{{storeValues:trackOrderContext.selectedMsisdn}}",
               eVar25: "{{storeValues:pincodeContext.pincodeDetails.circleId}}",
               isInteractive: 1,
               cartId: "{{storeValues:orderData.cartItemId}}",
               eventAction: "click",
               eventLabel: "retry",
               prop5: "{{storeValues:planInfo.planName}}",
               prop4: "SKYC",
               eventValue: "photo verification",
               eVar0: "skyc_click on retry_photo verification",
               customLabel: "button",
               prop45: "{{storeValues:appData.orderType}}",
               ticketId: "{{storeValues:orderData.cartId}}",
               prop26: ""
            },
         });
      }
      artistRef?.current?.onUserAction({
         actions,
      });
   };

   const onPressSubmit = async () => {
      if (!imageWithWaterMark) return;

      const reduxState = getReduxState?.();
      const storeValues = reduxState?.storeValues;
      const isNewSKYCJourney = storeValues?.journeyContext?.journey === 'SKYC_NEW';
      const circle = storeValues?.entityDetails?.circleId || '102';
      const circleId = storeValues?.pincodeContext?.pincodeDetails?.circleId;
      const consumerLob = storeValues?.appData?.lob;
      const actions = [];
      const journeyType = storeValues?.appData?.lob;
      const isPrepaidSimLayout = storeValues?.journeyContext?.layout === 'prepaid_sim_layout'
      let headers = {};

      let imageWithWaterMarkData: any = {
         imageValue: imageWithWaterMark,
         interactionId:  storeValues?.appData?.kyc?.kycId,
         latitude : latitude ? latitude : location?.latitude,
         longitude : longitude ? longitude : location?.longitude,
         lob: 'CUSTOMER_REVERIFICATION',
         imageType: 'USER_IMAGE',
         documentType: 'USER_IMAGE',
         source: 'SHOP_RV',
      };

      let rawImageData: any = {
         imageValue: rawImage,
         interactionId: storeValues?.appData?.kyc?.kycId,
         latitude : latitude ? latitude : location?.latitude,
         longitude : longitude ? longitude : location?.longitude,
         lob: 'CUSTOMER_REVERIFICATION',
         imageType: 'UNCROPPED_USER_IMAGE',
         documentType: 'UNCROPPED_USER_IMAGE',
         imageSameAsPoa: 'false',
         matchFaceWithImage: 'USER_UIDAI_IMAGE',
         source: 'SHOP_RV',
      };
      let imageKey = 'imageValue';

 
         imageKey = 'docFile';
         const kycId = storeValues?.appData?.kyc?.kycId;

         headers = {
            source: 'shop',
            'x-correlation-id': generateUniqueId(),
            'x-consumer-lob': consumerLob,
            circleId
         };

         rawImageData = {
            docFile: rawImage,
            docType: 'UNCROPPED_USER_IMAGE',
            kycId,
            kycType: 'SKYC',
            channel: 'SHOP',
            circle,
            latitude : latitude ? latitude : location?.latitude,
            longitude : longitude ? longitude : location?.longitude,
            journeyType,
            targetImageMatch: JSON.stringify([
               { targetImage: 'USER_UIDAI_IMAGE', correlationId: kycId },
            ]),
            requestTime: new Date().toISOString(),
         };

         imageWithWaterMarkData = {
            docFile: imageWithWaterMark,
            docType: 'USER_IMAGE',
            kycId,
            kycType: 'SKYC',
            channel: 'SHOP',
            circle,
            latitude : latitude ? latitude : location?.latitude,
            longitude : longitude ? longitude : location?.longitude,
            journeyType,
            requestTime: new Date().toISOString(),
         };
      
      const rawImageFormData = await prepareFormData(rawImageData, false, imageKey);
      const imageWithWaterMarkFormData = await prepareFormData(
         imageWithWaterMarkData,
         false,
         imageKey
      );

      const imageStore = ImageStore.getInstance();
      imageStore.setItem('waterMarkUserImage', imageWithWaterMarkFormData);

      if (isUploaded && isUploaded.current) {
         actions.push({
            payload: {
               args: ['closeWithoutUpload'],
               utilName: 'closeImageModalRevamp',
            },
            type: 'callUtilFunction',
         });
      } else {
         // let apiUrl = 'new-acq/dochub/doc-hub/upload/image';       
         let apiUrl = 'new-acq/dochub/doc-hub/upload/image';      
         actions.push(
            {
               type: 'fullPageLoader',
               payload: {
                  show: true,
               },
            },
            {
               type: 'apiCall',
               payload: {
                  requestType: 'POST',
                  apiUrl,
                  authTokenGroup: 'SKYC_REVERIFICATION',
                  ...{ headers },
                  body: rawImageFormData,
                  onSuccess: {
                     actions: [
                        {
                           payload: {
                              args: [],
                              utilName: 'handleFaceMatchResponseRevamp',
                           },
                           type: 'callUtilFunction',
                        },
                        {
                           analyticsAction: 'click',
                           analyticsData: {
                              eventCategory: 'SKYC_LANDING_PAGE',
                              section: 'stepssection',
                              subSection: 'step4Widget',
                              eventAction: 'pageclose',
                              eVar21: '{{storeValues:appData.msisdn}}',
                              extraData11: '{{storeValues:layoutContext.layout}}',
                              prop8: 'reverification',
                              prop7: '{{storeValues:siNumberStatusDetails.customerZone}}',
                              prop6: '{{storeValues:siNumberStatusDetails.actionRequired}}',
                              prop5: '{{storeValues:outstationContext.isOutstation}}',
                           },
                        },
                     ],
                  },
                  onError: {
                     actions: [
                        {
                           type: 'fullPageLoader',
                           payload: {
                              show: false,
                           },
                        },
                        {
                           type: 'showToast',
                           payload: {
                              title: 'something went wrong please try again',
                              dismissDuration: 5000,
                              position: 'bottom-center',
                              state: 'error',
                              style: {
                                 zIndex: 10000,
                              },
                           },
                        },
                        ...(isNewSKYCJourney ? [
                           {
                              analyticsAction: 'impression',
                              analyticsData: {
                                 eventCategory: 'NEW_ACQ_POSTPAID_SKYC',
                                 section: 'stepsSection',
                                 subSection: 'Step4Widget',
                                 eventAction: 'impression',
                                 eventLabel: 'retry',
                                 eventValue: 'ecaf',
                                 customValue: 'image upload failed',
                                 customLabel: 'card',
                                 prop35: '{{storeValues:orderData.orderData.cartId}}',
                                 extraData12: '{{storeValues:orderData.orderData.cartItemId}}',
                                 prop45: '{{storeValues:appData.subJourney}}',
                                 eVar21: '{{storeValues:appData.loggedInNumber}}',
                                 eVar36: '{{storeValues:appData.msisdn}}',
                                 city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
                                 eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleName}}',
                                 prop4: 'SKYC',
                                 extraData11: '{{storeValues:layoutContext.layout}}',
                                 prop7: '{{storeValues:outstationContext.isOutstation}}',
                                 prop9: '{{storeValues:appData.lob}}',
                                 eVar10: 'error'
                              },
                           }
                        ] : [])
                     ],
                  },
               },
            }
         );
      }
      if (!isPrepaidSimLayout) {
         if (isNewSKYCJourney) {
            actions?.push({
               analyticsAction: 'click',
               analyticsData: {
                  eventCategory: 'NEW_ACQ_POSTPAID_SKYC',
                  section: 'stepsSection',
                  subSection: 'Step4Widget',
                  eventAction: 'click',
                  eventLabel: 'submit',
                  eventValue: '',
                  customValue: '',
                  customLabel: 'button',
                  prop35: '{{storeValues:orderData.orderData.cartId}}',
                  extraData12: '{{storeValues:orderData.orderData.cartItemId}}',
                  prop45: '{{storeValues:appData.subJourney}}',
                  eVar21: '{{storeValues:appData.loggedInNumber}}',
                  eVar36: '{{storeValues:appData.msisdn}}',
                  city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
                  eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleName}}',
                  prop4: 'SKYC',
                  extraData11: '{{storeValues:layoutContext.layout}}',
                  prop7: '{{storeValues:outstationContext.isOutstation}}',
                  prop9: '{{storeValues:appData.lob}}'
               },
            });
         } else {
            actions.push({
               analyticsAction: 'click',
               analyticsData: {
                  eventCategory: 'SKYC_LANDING_PAGE',
                  section: 'stepssection',
                  subSection: 'Step4Widget',
                  eventAction: 'click',
                  eventLabel: 'submit picture',
                  eVar21: '{{storeValues:appData.msisdn}}',
                  extraData11: '{{storeValues:layoutContext.layout}}',
                  prop8: 'reverification',
                  prop6: '{{storeValues:siNumberStatusDetails.actionRequired}}',
                  prop7: '{{storeValues:siNumberStatusDetails.customerZone}}',
                  prop5: '{{storeValues:outstationContext.isOutstation}}',
               },
            });
         }
      } else {
         actions.push({
            analyticsAction: 'click',
            analyticsData: {
               eventCategory: "new_acq_postpaid_skyc",
               section: "stepsSection",
               subSection: "Step4Widget",
               eVar33: "{{storeValues:pincodeContext.pincodeDetails.pincode}}",
               eVar21: "{{storeValues:appData.msisdn}}",
               eVar20: "{{storeValues:appData.loggedInNumber}}",
               city: "{{storeValues:pincodeContext.pincodeDetails.city}}",
               customValue: "",
               eVar36: "{{storeValues:trackOrderContext.selectedMsisdn}}",
               eVar25: "{{storeValues:pincodeContext.pincodeDetails.circleId}}",
               isInteractive: 1,
               cartId: "{{storeValues:orderData.cartItemId}}",
               eventAction: "click",
               eventLabel: "submit",
               prop5: "{{storeValues:planInfo.planName}}",
               prop4: "SKYC",
               eventValue: "photo verification",
               eVar0: "skyc_click on submit_photo verification",
               customLabel: "button",
               prop45: "{{storeValues:appData.orderType}}",
               ticketId: "{{storeValues:orderData.cartId}}",
               prop26: ""
            },
         });

         actions?.push({
            payload: {
               args: [
                  {
                     dataLayer: {
                        stepName: '4|photo verification',
                        clicktext: '',
                        event: 'photo_verification_submit',
                     },
                  },
               ],
               utilName: 'handleGtmDataLayerEvent',
            },
            type: 'callUtilFunction',
         });
      }
      artistRef?.current?.onUserAction({
         actions,
      });
   };

   const getLatLongString = () => {

     const lat = latitude ? latitude : location?.latitude;
      const long = longitude ? longitude : location?.longitude;
      return !!lat && !!long
         ? `${parseFloat(lat).toFixed(3)}, ${parseFloat(long).toFixed(3)} `
         : '';
   };

   const getWatermarkLines = () => {
      const reduxState = getReduxState?.();
      const storeValues = reduxState?.storeValues;
      const isNewSKYCJourney = storeValues?.journeyContext?.journey === 'SKYC_NEW';
      const caFNumber = storeValues?.appData?.kyc?.cafNumber;

      return [
         caFNumber ? String(caFNumber) : '',
         getLatLongString(),
         convertTimestampToDate(new Date().getTime(), 'IMAGE_MODAL'),
      ]
         .map((line) => (line || '').trim())
         .filter((line) => line.length > 0);
   };

   const drawWatermark = (context: CanvasRenderingContext2D, height: number) => {
      const lines = getWatermarkLines();
      if (!lines.length) return;

      context.font = WATERMARK_FONT;
      context.textBaseline = 'alphabetic';

      const probe = context.measureText('Ag');
      const ascent = probe.actualBoundingBoxAscent || WATERMARK_FONT_SIZE * 0.8;
      const descent = probe.actualBoundingBoxDescent || WATERMARK_FONT_SIZE * 0.2;
      const lineBoxHeight = ascent + descent + 2 * WATERMARK_TEXT_BG_PADDING_V;

      const textBlockHeight =
         lines.length * lineBoxHeight +
         Math.max(0, lines.length - 1) * WATERMARK_LINE_SPACING;
      const totalContentHeight =
         WATERMARK_ICON_SIZE + WATERMARK_ICON_TO_TEXT_GAP + textBlockHeight;

      const contentLeft = WATERMARK_EDGE_PADDING_LEFT;
      const contentTop = height - WATERMARK_EDGE_PADDING_BOTTOM - totalContentHeight;

      if (airtelIconRef.current) {
         context.drawImage(
            airtelIconRef.current,
            contentLeft,
            contentTop,
            WATERMARK_ICON_SIZE,
            WATERMARK_ICON_SIZE
         );
      }

      const textBlockTop = contentTop + WATERMARK_ICON_SIZE + WATERMARK_ICON_TO_TEXT_GAP;

      lines.forEach((line, index) => {
         const textTop = textBlockTop + index * (lineBoxHeight + WATERMARK_LINE_SPACING);
         const lineWidth = context.measureText(line).width;
         const plateLeft = contentLeft - WATERMARK_TEXT_BG_PADDING_H;
         const plateWidth = lineWidth + 2 * WATERMARK_TEXT_BG_PADDING_H;

         context.fillStyle = WATERMARK_TEXT_BG_COLOR;

         if (typeof context.roundRect === 'function') {
            context.beginPath();
            context.roundRect(
               plateLeft,
               textTop,
               plateWidth,
               lineBoxHeight,
               WATERMARK_CORNER_RADIUS
            );
            context.fill();
         } else {
            // roundRect needs Chrome 99+/Safari 16+; square plate keeps text legible below that.
            context.fillRect(plateLeft, textTop, plateWidth, lineBoxHeight);
         }

         context.fillStyle = WATERMARK_TEXT_COLOR;
         context.fillText(line, contentLeft, textTop + ascent + WATERMARK_TEXT_BG_PADDING_V);
      });
   };

   const getProcessedImage = (imageSrc: string, withWatermark = false) => {
      if (!withWatermark) {
         return Promise.resolve(imageSrc);
      }

      return new Promise<string>((resolve, reject) => {
         const imageObj = new Image();

         imageObj.onerror = () => reject(new Error('Unable to load the captured image'));

         imageObj.onload = function () {
            try {
               const srcWidth = imageObj.width;
               const srcHeight = imageObj.height;

               if (!srcWidth || !srcHeight) {
                  reject(new Error('Captured image has invalid dimensions'));
                  return;
               }

               // Center-crop then scale; the guide circle keeps the face centered.
               const targetHeight = CROP_TARGET_HEIGHT;
               const targetWidth = Math.max(
                  1,
                  Math.round(targetHeight * CROP_PORTRAIT_ASPECT_RATIO)
               );
               const targetAspect = targetWidth / targetHeight;
               const srcAspect = srcWidth / srcHeight;

               let cropW: number;
               let cropH: number;

               if (srcAspect > targetAspect) {
                  cropH = srcHeight;
                  cropW = Math.max(1, Math.round(cropH * targetAspect));
               } else {
                  cropW = srcWidth;
                  cropH = Math.max(1, Math.round(cropW / targetAspect));
               }

               // NEW — zoom in around the same center point instead of taking the full axis
               cropW = Math.max(1, Math.round(cropW * ZOOM_FACTOR));
               cropH = Math.max(1, Math.round(cropH * ZOOM_FACTOR));

               const cropX = Math.max(0, Math.round((srcWidth - cropW) / 2));
               const cropY = Math.max(0, Math.round((srcHeight - cropH) / 2));

               const canvas = document.createElement('canvas');
               canvas.width = targetWidth;
               canvas.height = targetHeight;

               const context = canvas.getContext('2d');

               if (!context) {
                  reject(new Error('Unable to acquire a 2D canvas context'));
                  return;
               }

               context.clearRect(0, 0, canvas.width, canvas.height);
               context.imageSmoothingEnabled = true;
               context.imageSmoothingQuality = 'high';
               context.drawImage(
                  imageObj,
                  cropX,
                  cropY,
                  cropW,
                  cropH,
                  0,
                  0,
                  canvas.width,
                  canvas.height
               );

               drawWatermark(context, canvas.height);

               resolve(canvas.toDataURL('image/jpeg', JPEG_QUALITY));
            } catch (error) {
               // Throwing out of onload would leave the promise unsettled and the loader spinning.
               reject(error);
            }
         };

         imageObj.src = imageSrc;
      });
   };

   const handleFaceMatchModalClose = () => {
      setShowFaceMathError?.(false);
      onPressRetry();
   };

   const closeImageModalWithError = () => {
      closeCameraModalWithErrorAction('image', artistRef);
   };

   useEffect(() => {
      (async function () {
         try {
            const result = await fetch(faviconIcon);
            const blob = await result.blob();
            airtelIconRef.current = await createImageBitmap(blob)
         } catch {
            // Watermarks without the logo, as the native drawWatermark does.
            // createImageBitmap is unsupported below Safari 15.
            airtelIconRef.current = null;
         }
      })();
   },[])

   return (
      <Modal visible={visible} animationType="slide" transparent={false}>
         <ModalCloseButton onPress={setIsImageModalOpen} />
         <AModal
            initialVisible={showFaceMatchError}
            swipeEnabled={false}
            onCloseHandler={handleFaceMatchModalClose}
            showCross
         >
            <StatusCardWidget
               title={{
                  text: 'Error during photo validation',
               }}
               subtitle={{
                  text: faceMathErrorText,
               }}
               statusCardImage={{
                  imageUrl:
                     'https://assets.airtel.in/static-assets/acq-skyc/aadhaar-photo-mis-match.png',
               }}
               type="image"
               primaryCtaTitle="Retry"
               primaryButtonType="primary"
               primaryButtonVersion="variable-width"
               ctaDirection="column"
               buttonWidgetProps={{
                  leftCta: {
                     onPress: handleFaceMatchModalClose,
                  },
               }}
            />
         </AModal>
         <div className="image-modal-new">
            <div
               className="image-container">
               {imageWithWaterMark ? (
                  /* Previews the clean frame; gated on the processed copy being ready. */
                  <ImagePreview src={rawImage} />
               ) : (
                  <>
                     {loader && <FullScreenLoader />}

                    {visible && <FaceDetection
                        ref={faceDetectionRef}
                        style={{
                           width: '100%',
                           height: '100%',
                        }}
                        circleConfig={{
                           height: 342,
                           width: 320,
                           borderRadius: 322,
                           borderWidth: 2,
                           borderColor: '#ffffff',
                           borderColorOnSuccess: '#22C55E',
                           borderColorOnError: '#EF4444',
                        }}
                        isAutoCaptureEnabled={false}
                        onDetectChange={({ isValid, errorCode }) => {
                           applyErrorCode(isValid, errorCode);
                        }}
                        onCapture={({ imageBlob }) => {
                           handleFaceCaptureResult(imageBlob);
                        }}
                        onPermissionChange={({ type }) => {
                           if (type === 'DENIED') {
                              closeImageModalWithError();
                           } else if (type === 'GRANTED') {
                              setLoader(false);
                           } else if (type === 'PENDING') {
                              faceDetectionRef.current?.askPermission();
                           }
                        }}
                        onException={() => {
                           closeImageModalWithError();
                        }}
                     />}

                     {!loader && (
                        <div className="image-focus-overlay">
                           {detectedFaceCount !== null && detectedFaceCount !== 1 && (
                              <div className="img-error-callout">
                                 <Callout
                                    description={
                                       eyesCallout ? 'Ensure that your eyes are open in the photo.' :
                                          detectedFaceCount === 0
                                             ? 'Ensure that your face is clearly visible in the photo.'
                                             : 'Multiple faces detected.'
                                    }
                                    iconName="AlertMediumIcon"
                                    state="error"
                                    version="variable-width"
                                 />
                              </div>
                           )}
                           {detectedFaceCount === 1 && eyesCallout && (
                              <div className="img-error-callout">
                                 <Callout
                                    description={'Ensure that your eyes are open in the photo.'}
                                    iconName="AlertMediumIcon"
                                    state="error"
                                    version="variable-width"
                                 />
                              </div>
                           )}
                           
                            {/* {detectedFaceCount === 1 &&(
                              <div className="img-error-callout">
                                 <Callout
                                    description={'Ensure that the photo is captured in good lighting conditions'}
                                    iconName="AlertMediumIcon"
                                    state="error"
                                    version="variable-width"
                                 />
                              </div>
                           )} */}
                        </div>
                     )}
                  </>
               )}
            </div>
            <div className="btn-container">
               {imageWithWaterMark ? (
                  <ButtonWidget
                     direction="row"
                     leftCta={{
                        size: 'md',
                        buttonType: 'secondary',
                        title: 'Retake',
                        onPress: onPressRetry,
                     }}
                     rightCta={{
                        size: 'md',
                        buttonType: 'primary',
                        title: 'Proceed to record video',
                        onPress: onPressSubmit,
                     }}
                     style={{
                        width: '100%',
                     }}
                     leftCtaContainerStyle={{
                        flex: 3,
                     }}
                     rightCtaContainerStyle={{
                        flex: 7,
                     }}
                  />
               ) : (
                  <>
                     <Typography
                        type="body-para-md-bold"
                        text="Position your face in the center"
                        style={{
                           marginBottom: 16,
                        }}
                     />
                     <IconButton
                        iconName="CameraOnFilledIcon"
                        onPress={capturePhoto}
                        size="lg"
                        theme="light"
                        type="primary"
                        variant="icon"
                        disabled={loader || !isFaceValid}
                     />
                  </>
               )}
            </div>
         </div>
      </Modal>
   );
};

export default ImageModalRevamp;
